export class HttpError {
  public readonly statusCode: number;
  public readonly message: string;

  constructor({status, statusText}: Response) {
    this.statusCode = status;
    this.message = status + ' - ' + statusText;
  }
}
